import { render, staticRenderFns } from "./DadoConteudo.vue?vue&type=template&id=02d8f14c&scoped=true"
import script from "./DadoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./DadoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DadoConteudo.vue?vue&type=style&index=0&id=02d8f14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d8f14c",
  null
  
)

export default component.exports